import PropTypes from "prop-types";
import sampleImage from "../../../assets/img/sample/image 23.png";
import { getImageUrl, isImage, ratesTooltip, rateMsg } from "../../../utils";
import Input from "../../commonComponents/Input";
import Label from "../../commonComponents/Label";
import ToolTip from "../../common/Tooltip";
import { useSelector } from "react-redux";
const GraphicsAndDesign = (props) => {
  const {
    service,
    setNoSamplesAvailable,
    handleChange,
    setuploadSamples,
    uploadSamples,
    handleOpenSampleModal,
    handleChangeService = () => {},
    handleEnlarge,
    clearSamples = () => {},
    removeURL,
    handleDeleteMedia,
    index
  } = props;

  const error = useSelector((state) => state.ProfileReducer?.typeError);
  const handleDocEnlarge = (e, url = "", type = "image") => {
    if (type === "image") {
      if (isImage(url)) {
        handleEnlarge({ url: url, show: true, type });
      } else {
        window.open(url);
      }
    } else {
      handleEnlarge({ url: url, show: true, type });
    }
  };

  const renderUploadedSamples = (service) => {
    if (service?.samples?.length > 0) {
      if (service?.samples[0]?.uploadSamples) {
        return (
          <>
            <div class="imgWrap-opt">
              <a
                onClick={() => handleDeleteMedia(service?.samples[0], service)}
              >
                <b class="icon-bin"></b>
              </a>
              <a>
                <b
                  class="icon-fullscreen"
                  onClick={(e) =>
                    handleDocEnlarge(
                      e,
                      service?.samples[0]?.uploadSamples,
                      "image"
                    )
                  }
                ></b>
              </a>
            </div>
            <img
              src={getImageUrl(service?.samples[0]?.uploadSamples)}
              alt="#"
            />
          </>
        );
      }
      return (
        <>
          <div class="urlWrap">
            <b class="icon-link urlWrap-icon"></b>
            <p class="urlWrap-url">{service?.samples[0]?.url}</p>
            <div class="urlWrap-opt">
              <a
                onClick={(e) =>
                  handleEnlarge({
                    url: service?.samples[0]?.url,
                    show: true,
                    type: "url",
                  })
                }
              >
                <b class="icon-fullscreen"></b>
              </a>
              <a onClick={() => removeURL(service?.samples[0], service)}>
                <b class="icon-bin"></b>
              </a>
            </div>
          </div>
        </>
      );
    }
    return (
      <a
        className="w-auto"
        onClick={() => handleOpenSampleModal(service)}
        class="uploadBtn w-100 ms-0"
      >
        <b class="icon-upload"></b>Upload
      </a>
    );
  };

  return (
    <div class="fieldSet">
      <div class="pt-2">
        <div class="pb-3 theme-secoundry_checkbox">
          <h2 class="mb-1 titleText">
            Rates
            <ToolTip placement="top" toolTipMessage={rateMsg()}>
              <a class="infoMark">i</a>
            </ToolTip>
          </h2>
          <div class="serviceRates">
            <div class="serviceRates-col mt-3">
              <Label className="styledCheck">
                <input
                  type="checkbox"
                  name="rateChecked"
                  checked={service?.rateChecked}
                  onChange={(e) =>
                    handleChange(e, service, "headerLevelChecked", "rates")
                  }
                />
                <span className="text-black">
                  Designs using copyright free images, symbols and/or graphics.
                </span>{" "}
              </Label>
              <ul class="rateList mt-2 ps-4">
                <li>
                  <div class="rateLevel pt-0">
                    <div class="rateCheck">
                      {" "}
                      <Label className="styledCheck">
                        <input
                          type="checkbox"
                          disabled={!service?.rateChecked}
                          name="levelChecked"
                          checked={service?.rates?.[0]?.levelChecked}
                          onChange={(e) => handleChange(e, service, 0, "rates")}
                        />
                        <span>Single Colour</span>
                      </Label>
                    </div>
                    <div class="minMax">
                      <div class="minMax-col">
                        <Label className="ps-2" labelText="₹ Minimum" />
                        <Input
                          type="number"
                          name="min"
                          min={0}
                          value={service?.rates?.[0]?.level?.min}
                          required={service?.rates?.[0]?.levelChecked}
                          handleChange={(e) =>
                            handleChange(e, service, 0, "rates")
                          }
                          readOnly={!service?.rates?.[0]?.levelChecked}
                        />
                      </div>
                      <div class="minMax-dash">-</div>
                      <div class="minMax-col">
                        <Label className="ps-2" labelText="₹ Maximum" />
                        <Input
                          type="number"
                          name="max"
                          min={0}
                          className="form-control grey-input"
                          value={service?.rates?.[0]?.level?.max}
                          required={service?.rates?.[0]?.levelChecked}
                          handleChange={(e) =>
                            handleChange(e, service, 0, "rates")
                          }
                          readOnly={!service?.rates?.[0]?.levelChecked}
                        />
                      </div>
                      <div class="minMax-post">/Graphic</div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="rateLevel">
                    <div class="rateCheck">
                      {" "}
                      <Label className="styledCheck">
                        <input
                          type="checkbox"
                          name="levelChecked"
                          disabled={!service?.rateChecked}
                          checked={service?.rates?.[1]?.levelChecked}
                          onChange={(e) => handleChange(e, service, 1, "rates")}
                        />
                        <span>Two Colour</span>
                      </Label>
                    </div>
                    <div class="minMax">
                      <div class="minMax-col">
                        <Input
                          type="number"
                          name="min"
                          min={0}
                          value={service?.rates?.[1]?.level?.min}
                          required={service?.rates?.[1]?.levelChecked}
                          handleChange={(e) =>
                            handleChange(e, service, 1, "rates")
                          }
                          readOnly={!service?.rates?.[1]?.levelChecked}
                        />
                      </div>
                      <div class="minMax-dash pt-0">-</div>
                      <div class="minMax-col">
                        <Input
                          type="number"
                          name="max"
                          min={0}
                          value={service?.rates?.[1]?.level.max}
                          required={service?.rates?.[1]?.levelChecked}
                          handleChange={(e) =>
                            handleChange(e, service, 1, "rates")
                          }
                          readOnly={!service?.rates?.[1]?.levelChecked}
                        />
                      </div>
                      <div class="minMax-post pt-0">/Graphic</div>
                    </div>
                  </div>
                </li>

                <li>
                  <div class="rateLevel">
                    <div class="rateCheck">
                      {" "}
                      <Label className="styledCheck">
                        <input
                          type="checkbox"
                          name="levelChecked"
                          disabled={!service?.rateChecked}
                          checked={service?.rates?.[2]?.levelChecked}
                          onChange={(e) => handleChange(e, service, 2, "rates")}
                        />
                        <span>Multi Colour</span>
                      </Label>
                    </div>
                    <div class="minMax">
                      <div class="minMax-col">
                        <Input
                          type="number"
                          name="min"
                          min={0}
                          value={service?.rates?.[2]?.level?.min}
                          required={service?.rates?.[2]?.levelChecked}
                          handleChange={(e) =>
                            handleChange(e, service, 2, "rates")
                          }
                          readOnly={!service?.rates?.[2]?.levelChecked}
                        />
                      </div>
                      <div class="minMax-dash pt-0">-</div>
                      <div class="minMax-col">
                        <Input
                          type="number"
                          name="max"
                          value={service?.rates?.[2]?.level.max}
                          required={service?.rates?.[2]?.levelChecked}
                          handleChange={(e) =>
                            handleChange(e, service, 2, "rates")
                          }
                          readOnly={!service?.rates?.[2]?.levelChecked}
                        />
                      </div>
                      <div class="minMax-post pt-0">/Graphic</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="serviceRates-col mt-3">
              <Label className="styledCheck">
                <input
                  type="checkbox"
                  name="useOfOriginalChecked"
                  checked={service?.useOfOriginalChecked}
                  onChange={(e) =>
                    handleChange(
                      e,
                      service,
                      "headerLevelChecked",
                      "useOfOriginal"
                    )
                  }
                />
                <span className="text-black">
                  Designs using original Illustration/Symbols/Graphics
                  (Freehand)
                </span>{" "}
              </Label>
              <ul class="rateList mt-2 ps-4">
                <li>
                  <div class="rateLevel pt-0">
                    <div class="rateCheck">
                      {" "}
                      <Label className="styledCheck">
                        <input
                          type="checkbox"
                          name="levelChecked"
                          disabled={!service?.useOfOriginalChecked}
                          checked={service?.useOfOriginal?.[0]?.levelChecked}
                          onChange={(e) =>
                            handleChange(e, service, 0, "useOfOriginal")
                          }
                        />
                        <span>Single Colour</span>
                      </Label>
                    </div>
                    <div class="minMax">
                      <div class="minMax-col">
                        <Label className="ps-2" labelText="₹ Minimum"></Label>
                        <Input
                          type="number"
                          name="min"
                          min={0}
                          value={service?.useOfOriginal?.[0]?.level?.min}
                          required={service?.useOfOriginal?.[0]?.levelChecked}
                          handleChange={(e) =>
                            handleChange(e, service, 0, "useOfOriginal")
                          }
                          readOnly={!service?.useOfOriginal?.[0]?.levelChecked}
                        />
                      </div>
                      <div class="minMax-dash">-</div>
                      <div class="minMax-col">
                        <Label className="ps-2" labelText="₹ Maximum"></Label>
                        <Input
                          type="number"
                          name="max"
                          min={0}
                          value={service?.useOfOriginal[0]?.level.max}
                          required={service?.useOfOriginal[0]?.levelChecked}
                          handleChange={(e) =>
                            handleChange(e, service, 0, "useOfOriginal")
                          }
                          readOnly={!service?.useOfOriginal[0]?.levelChecked}
                        />
                      </div>
                      <div class="minMax-post">/Graphic</div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="rateLevel">
                    <div class="rateCheck">
                      {" "}
                      <Label className="styledCheck">
                        <input
                          type="checkbox"
                          name="levelChecked"
                          disabled={!service?.useOfOriginalChecked}
                          checked={service?.useOfOriginal?.[1]?.levelChecked}
                          onChange={(e) =>
                            handleChange(e, service, 1, "useOfOriginal")
                          }
                        />
                        <span>Two Colour</span>
                      </Label>
                    </div>
                    <div class="minMax">
                      <div class="minMax-col">
                        <Input
                          type="number"
                          name="min"
                          min={0}
                          value={service?.useOfOriginal?.[1]?.level?.min}
                          required={service?.useOfOriginal?.[1]?.levelChecked}
                          handleChange={(e) =>
                            handleChange(e, service, 1, "useOfOriginal")
                          }
                          readOnly={!service?.useOfOriginal?.[1]?.levelChecked}
                        />
                      </div>
                      <div class="minMax-dash pt-0">-</div>
                      <div class="minMax-col">
                        <Input
                          type="number"
                          name="max"
                          min={0}
                          value={service?.useOfOriginal[1]?.level.max}
                          required={service?.useOfOriginal[1]?.levelChecked}
                          handleChange={(e) =>
                            handleChange(e, service, 1, "useOfOriginal")
                          }
                          readOnly={!service?.useOfOriginal[1]?.levelChecked}
                        />
                      </div>
                      <div class="minMax-post pt-0">/Graphic</div>
                    </div>
                  </div>
                </li>

                <li>
                  <div class="rateLevel">
                    <div class="rateCheck">
                      {" "}
                      <Label className="styledCheck">
                        <input
                          type="checkbox"
                          name="levelChecked"
                          disabled={!service?.useOfOriginalChecked}
                          checked={service?.useOfOriginal?.[2]?.levelChecked}
                          onChange={(e) =>
                            handleChange(e, service, 2, "useOfOriginal")
                          }
                        />
                        <span>Multi Colour</span>
                      </Label>
                    </div>
                    <div class="minMax">
                      <div class="minMax-col">
                        <Input
                          type="number"
                          name="min"
                          min={0}
                          value={service?.useOfOriginal?.[2]?.level?.min}
                          required={service?.useOfOriginal?.[2]?.levelChecked}
                          handleChange={(e) =>
                            handleChange(e, service, 2, "useOfOriginal")
                          }
                          readOnly={!service?.useOfOriginal?.[2]?.levelChecked}
                        />
                      </div>
                      <div class="minMax-dash pt-0">-</div>
                      <div class="minMax-col">
                        <Input
                          type="number"
                          name="max"
                          min={0}
                          value={service?.useOfOriginal[2]?.level.max}
                          required={service?.useOfOriginal[2]?.levelChecked}
                          handleChange={(e) =>
                            handleChange(e, service, 2, "useOfOriginal")
                          }
                          readOnly={!service?.useOfOriginal[2]?.levelChecked}
                        />
                      </div>
                      <div class="minMax-post pt-0">/Graphic</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            {service.serviceType !== "Book Cover Design" && (
              <>
                <div class="serviceRates-col mt-3">
                  <Label className="styledCheck">
                    <input
                      type="checkbox"
                      name="tableDesignChecked"
                      checked={service?.tableDesignChecked}
                      onChange={(e) =>
                        handleChange(
                          e,
                          service,
                          "headerLevelChecked",
                          "tableDesign"
                        )
                      }
                    />
                    <span className="text-black">Table Design</span>{" "}
                  </Label>
                  <ul class="rateList mt-2 ps-4">
                    <li>
                      <div class="rateLevel pt-0">
                        <div class="rateCheck">
                          {" "}
                          <Label className="styledCheck">
                            <input
                              type="checkbox"
                              name="levelChecked"
                              disabled={!service?.tableDesignChecked}
                              checked={service?.tableDesign?.[0]?.levelChecked}
                              onChange={(e) =>
                                handleChange(e, service, 0, "tableDesign")
                              }
                            />
                            <span>Single Colour</span>
                          </Label>
                        </div>
                        <div class="minMax">
                          <div class="minMax-col">
                            <Label className="ps-2" labelText="₹ Minimum" />
                            <Input
                              type="number"
                              name="min"
                              min={0}
                              value={service?.tableDesign?.[0]?.level?.min}
                              required={service?.tableDesign?.[0]?.levelChecked}
                              handleChange={(e) =>
                                handleChange(e, service, 0, "tableDesign")
                              }
                              readOnly={
                                !service?.tableDesign?.[0]?.levelChecked
                              }
                            />
                          </div>
                          <div class="minMax-dash">-</div>
                          <div class="minMax-col">
                            <Label
                              className="ps-2"
                              labelText="₹ Maximum"
                            ></Label>
                            <Input
                              type="number"
                              name="max"
                              min={0}
                              value={service?.tableDesign[0]?.level.max}
                              required={service?.tableDesign[0]?.levelChecked}
                              handleChange={(e) =>
                                handleChange(e, service, 0, "tableDesign")
                              }
                              readOnly={!service?.tableDesign[0]?.levelChecked}
                            />
                          </div>
                          <div class="minMax-post">/Image</div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="rateLevel">
                        <div class="rateCheck">
                          {" "}
                          <Label className="styledCheck">
                            <input
                              type="checkbox"
                              name="levelChecked"
                              disabled={!service?.tableDesignChecked}
                              checked={service?.tableDesign?.[1]?.levelChecked}
                              onChange={(e) =>
                                handleChange(e, service, 1, "tableDesign")
                              }
                            />
                            <span>Two Colour</span>
                          </Label>
                        </div>
                        <div class="minMax">
                          <div class="minMax-col">
                            <Input
                              type="number"
                              name="min"
                              min={0}
                              value={service?.tableDesign?.[1]?.level?.min}
                              required={service?.tableDesign?.[1]?.levelChecked}
                              handleChange={(e) =>
                                handleChange(e, service, 1, "tableDesign")
                              }
                              readOnly={
                                !service?.tableDesign?.[1]?.levelChecked
                              }
                            />
                          </div>
                          <div class="minMax-dash pt-0">-</div>
                          <div class="minMax-col">
                            <Input
                              type="number"
                              name="max"
                              min={0}
                              value={service?.tableDesign[1]?.level.max}
                              required={service?.tableDesign[1]?.levelChecked}
                              handleChange={(e) =>
                                handleChange(e, service, 1, "tableDesign")
                              }
                              readOnly={!service?.tableDesign[1]?.levelChecked}
                            />
                          </div>
                          <div class="minMax-post pt-0">/Image</div>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div class="rateLevel">
                        <div class="rateCheck">
                          {" "}
                          <Label className="styledCheck">
                            <input
                              type="checkbox"
                              name="levelChecked"
                              disabled={!service?.tableDesignChecked}
                              checked={service?.tableDesign?.[2]?.levelChecked}
                              onChange={(e) =>
                                handleChange(e, service, 2, "tableDesign")
                              }
                            />
                            <span>Multi Colour</span>
                          </Label>
                        </div>
                        <div class="minMax">
                          <div class="minMax-col">
                            <Input
                              type="number"
                              name="min"
                              min={0}
                              value={service?.tableDesign?.[2]?.level?.min}
                              required={service?.tableDesign?.[2]?.levelChecked}
                              handleChange={(e) =>
                                handleChange(e, service, 2, "tableDesign")
                              }
                              readOnly={
                                !service?.tableDesign?.[2]?.levelChecked
                              }
                            />
                          </div>
                          <div class="minMax-dash pt-0">-</div>
                          <div class="minMax-col">
                            <Input
                              type="number"
                              name="max"
                              min={0}
                              value={service?.tableDesign[2]?.level.max}
                              required={service?.tableDesign[2]?.levelChecked}
                              handleChange={(e) =>
                                handleChange(e, service, 2, "tableDesign")
                              }
                              readOnly={!service?.tableDesign[2]?.levelChecked}
                            />
                          </div>
                          <div class="minMax-post pt-0">/Image</div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="serviceRates-col mt-3">
                  <Label className="styledCheck">
                    <input
                      type="checkbox"
                      name="formulaeChecked"
                      checked={service?.formulaeChecked}
                      onChange={(e) =>
                        handleChange(
                          e,
                          service,
                          "headerLevelChecked",
                          "formulae"
                        )
                      }
                    />
                    <span className="text-black">Formulae</span>{" "}
                  </Label>
                  <ul class="rateList mt-2 ps-4">
                    <li>
                      <div class="rateLevel pt-0">
                        <div class="rateCheck">
                          {" "}
                          <Label className="styledCheck">
                            <input
                              type="checkbox"
                              name="levelChecked"
                              disabled={!service?.formulaeChecked}
                              checked={service?.formulae?.[0]?.levelChecked}
                              onChange={(e) =>
                                handleChange(e, service, 0, "formulae")
                              }
                            />
                            <span>Single Colour</span>
                          </Label>
                        </div>
                        <div class="minMax">
                          <div class="minMax-col">
                            <Label className="ps-2" labelText="₹ Minimum" />
                            <Input
                              type="number"
                              min={0}
                              name="min"
                              value={service?.formulae?.[0]?.level?.min}
                              required={service?.formulae?.[0]?.levelChecked}
                              handleChange={(e) =>
                                handleChange(e, service, 0, "formulae")
                              }
                              readOnly={!service?.formulae?.[0]?.levelChecked}
                            />
                          </div>
                          <div class="minMax-dash">-</div>
                          <div class="minMax-col">
                            <Label className="ps-2" labelText="₹ Maximum" />
                            <Input
                              type="number"
                              name="max"
                              min={0}
                              value={service?.formulae[0]?.level.max}
                              required={service?.formulae[0]?.levelChecked}
                              handleChange={(e) =>
                                handleChange(e, service, 0, "formulae")
                              }
                              readOnly={!service?.formulae[0]?.levelChecked}
                            />
                          </div>
                          <div class="minMax-post">/Image</div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="rateLevel">
                        <div class="rateCheck">
                          {" "}
                          <Label className="styledCheck">
                            <input
                              type="checkbox"
                              name="levelChecked"
                              disabled={!service?.formulaeChecked}
                              checked={service?.formulae?.[1]?.levelChecked}
                              onChange={(e) =>
                                handleChange(e, service, 1, "formulae")
                              }
                            />
                            <span>Two Colour</span>
                          </Label>
                        </div>
                        <div class="minMax">
                          <div class="minMax-col">
                            <Input
                              type="number"
                              name="min"
                              min={0}
                              value={service?.formulae?.[1]?.level?.min}
                              required={service?.formulae?.[1]?.levelChecked}
                              handleChange={(e) =>
                                handleChange(e, service, 1, "formulae")
                              }
                              readOnly={!service?.formulae?.[1]?.levelChecked}
                            />
                          </div>
                          <div class="minMax-dash pt-0">-</div>
                          <div class="minMax-col">
                            <Input
                              type="number"
                              name="max"
                              min={0}
                              value={service?.formulae[1]?.level.max}
                              required={service?.formulae[1]?.levelChecked}
                              handleChange={(e) =>
                                handleChange(e, service, 1, "formulae")
                              }
                              readOnly={!service?.formulae[1]?.levelChecked}
                            />
                          </div>
                          <div class="minMax-post pt-0">/Image</div>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div class="rateLevel">
                        <div class="rateCheck">
                          {" "}
                          <Label className="styledCheck">
                            <input
                              type="checkbox"
                              name="levelChecked"
                              disabled={!service?.formulaeChecked}
                              checked={service?.formulae?.[2]?.levelChecked}
                              onChange={(e) =>
                                handleChange(e, service, 2, "formulae")
                              }
                            />
                            <span>Multi Colour</span>
                          </Label>
                        </div>
                        <div class="minMax">
                          <div class="minMax-col">
                            <Input
                              type="number"
                              name="min"
                              value={service?.formulae?.[2]?.level?.min}
                              required={service?.formulae?.[2]?.levelChecked}
                              handleChange={(e) =>
                                handleChange(e, service, 2, "formulae")
                              }
                              readOnly={!service?.formulae?.[2]?.levelChecked}
                            />
                          </div>
                          <div class="minMax-dash pt-0">-</div>
                          <div class="minMax-col">
                            <Input
                              type="number"
                              name="max"
                              min={0}
                              value={service?.formulae[2]?.level.max}
                              required={service?.formulae[2]?.levelChecked}
                              handleChange={(e) =>
                                handleChange(e, service, 2, "formulae")
                              }
                              readOnly={!service?.formulae[2]?.levelChecked}
                            />
                          </div>
                          <div class="minMax-post pt-0">/Image</div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </>
            )}
          </div>
        </div>
        <div class="pt-3">
          <h2 class="mb-1 titleText">
            Upload Sample Work{" "}
            <small className="labelBadge">Mandatory</small>
            <a
              onClick={
                () => handleOpenSampleModal(service)
                // alert('ssds')
              }
              class="uploadLink ms-4 link"
            >
              <b class="icon-upload"></b>Upload
            </a>
          </h2>
          <p class="sampleText">Show your best work to the customers</p>
          <small class="sampleNote">You can upload upto 6 samples</small>
          <p class="sampleCond">
            <span>
              Accepted Formats: <b>PDF/PNG/JPG/Tiff</b>
            </span>
            <span>
              Size Limit: <b>50MB</b>
            </span>
          </p>

          <div class="sampleUpload mb-3">
            <div class="sampleUpload-file">
              <div class="imgWrap">{renderUploadedSamples(service)}</div>
            </div>
            <div class="sampleUpload-more">
              {service?.samples?.length - 1 > 0 && (
                <a
                  href="#"
                  onClick={(e) => props.handleShowSamples(e, service?.samples)}
                >
                  +{service?.samples?.length - 1}
                </a>
              )}
              <small
                onClick={(e) =>
                  service?.samples.length > 0
                    ? props.handleShowSamples(e, service?.samples)
                    : ""
                }
              >
                <span>
                  <b className="icon-fullscreen" />
                </span>
                Click this button to enlarge the image
              </small>
            </div>
          </div>

          
          <label class="styledCheck">
            <input
              type="checkbox"
              onChange={(e) => {clearSamples(service); handleChangeService(e, service, 'not_have_any_samples')}}
              checked={service?.not_have_any_samples}
              />
          <span>I don’t have any samples to upload</span>
          </label>
          <small class="sampleNote mt-1 pe-4">
            Showcasing your work increases your chances of customers wanting to
            work with you.
          </small>
          <small className="sampleNote">
            You can upload your work later also.
          </small>
          {error?.type === `uploadSampleError-${index}` && (
            <div ref={ref => ref?.scrollIntoView()} className="label-error">{error?.message}</div>
          )}

          <div className="sevahaat-text">
            <span>*Seva Haat Service Fee Applicable</span>
            <p>
              Since this task is performed on our platform,
              <br />a service fee of 20% shall be applicable.
            </p>
          </div>
        </div>
      </div>
      {/* <ProfileUploadModal show={uploadSamples} /> */}
    </div>
  );
};
GraphicsAndDesign.propTypes = {
  service: PropTypes.objectOf(PropTypes.string),
  setuploadSamples: PropTypes.func,
  uploadSamples: PropTypes.bool,
  handleChange: PropTypes.func,
  handleOpenSampleModal: PropTypes.func,
  handleEnlarge: PropTypes.func,
  removeURL: PropTypes.func,
  handleDeleteMedia: PropTypes.func,
};

GraphicsAndDesign.defaultProps = {
  service: {},
  setuploadSamples: () => null,
  uploadSamples: false,
  handleChange: () => null,
  handleOpenSampleModal: () => null,
  handleEnlarge: () => null,
  removeURL: () => null,
  handleDeleteMedia: () => null,
};
export default GraphicsAndDesign;
